import { PopulationAndType } from '../../utils/dataTypes';
import DiagnosisSection from './DiagnosisSection';
import { components } from '../../api/types';

type Quantiles = components['schemas']['Quantiles'] | null;
type Props = {
  // diagnoses: Diagnosis[],
  // diagnosesStats: Diagnoses,

  /* Diagnosis data */
  diagnosisNames: string[];
  diagnosisLabels: (string | null)[];
  oddsRatios: (number | null)[];

  /* Measure data */
  measureNames: string[];
  actualScores: (number | null)[];
  actualPercentileRanks: (number | null)[];
  correlationPercents: number[][];
  takenMeasureMask: boolean[];
  quantiles: Quantiles[];
  
  colorClass: string,
  consensusText: string,
  concludingText: string,
  population: PopulationAndType,
};

/**
 * 
 */
export const DiagnosisList = ({
  diagnosisNames,
  diagnosisLabels,
  oddsRatios,

  measureNames,
  actualScores,
  actualPercentileRanks,
  correlationPercents,
  takenMeasureMask,
  quantiles,

  colorClass,
  consensusText,
  concludingText,
  population,
}: Props): JSX.Element => {
  // const [diagnosisOdds, setDiagnosisOdds] = useState<DiagnosisOdds[]>([]);

  // useEffect(() => {
  //   const getOddsRatio = (d: string) => {
  //     const s = diagnosesStats[d];
  //     return s && s.prior != null && s.prior !== 0 ? s.posterior / s.prior : 0;
  //   };
  //   const sortedDiagnoses = [...diagnoses].sort((a, b) => getOddsRatio(b.diagnosis) - getOddsRatio(a.diagnosis));
  //   const oddsByDiagnosis: DiagnosisOdds[] = sortedDiagnoses.map(({ diagnosis }: { diagnosis: string }) => {
  //     return(
  //       { diagnosis: diagnosis, oddsRatio: getOddsRatio(diagnosis) }
  //     );
  //   });
  //   setDiagnosisOdds(oddsByDiagnosis);
  // }, [diagnoses, diagnosesStats, colorClass, consensusText, concludingText]);

  return ( 
    <div className="diagnosisCategory">
      <p className="text content">
        InsightCare <span className={colorClass}>{consensusText}</span> {concludingText}
      </p>
      <div className={`${colorClass} expandable`}> 
        {
          // diagnosisOdds.map(({ diagnosis, oddsRatio }: { diagnosis: string, oddsRatio: number }) => {
          diagnosisNames.map((_, i: number) => {
            return (
              <DiagnosisSection
                diagnosisName={diagnosisNames[i]}
                diagnosisLabel={diagnosisLabels[i]}
                oddsRatio={oddsRatios[i]}
                // diagnosesStats={diagnosesStats}
                measureNames={measureNames}
                actualScores={actualScores}
                actualPercentileRanks={actualPercentileRanks}
                correlationPercents={correlationPercents[i]}
                takenMeasureMask={takenMeasureMask}
                quantiles={quantiles}

                population={population}
              />
            )
          })
        }
      </div>
    </div>
  )
};

export default DiagnosisList;